import { useQuery } from '@tanstack/react-query';
import request from 'utils/request';
import { useSchoolSchoolyear } from 'containers/App/context/SchoolyearSchoolProvider';
import { EVENTS_KEY } from 'containers/CahierJournal/queries/useCJSeances';
import { format } from 'utils/time/format';
import { Color } from 'types/colors';

interface Props {
  from: Date;
  to: Date;
}

function getVolume({
  from,
  to,
  schoolyearId,
  schoolId,
}: Props & { schoolyearId: string; schoolId: string }) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/cahier-journal/volume?from=${format(
    from,
    'fr-FR',
  )}&to=${format(to, 'fr-FR')}`;
  return request(requestURL, {
    method: 'GET',
  }).then<ClassroomWithVolume[]>(({ data }) => data);
}

export const CAHIER_JOURNAL_VOLUME_KEY = 'volume';

interface TagWithVolume {
  id?: string;
  name?: string;
  color?: Color;
  volumeInMinutes: number;
}

interface ClassroomWithVolume {
  id: string;
  name: string;
  tags: TagWithVolume[];
}

export function useGetVolume(props: Props) {
  const { schoolyear, school } = useSchoolSchoolyear();
  const { from, to } = props;
  return useQuery({
    queryKey: [
      schoolyear.id,
      school.id,
      EVENTS_KEY,
      CAHIER_JOURNAL_VOLUME_KEY,
      from,
      to,
    ],
    queryFn: () =>
      getVolume({
        ...props,
        schoolyearId: schoolyear.id,
        schoolId: school.id,
      }),

    refetchOnWindowFocus: false,
  });
}
